module.exports = require("@vscode-alt/monaco-editor/esm/vs/editor/common/core/position");